import ScheduleService from "@/services/scheduleService";
import moment from "moment";

const statusColours = {
    Assigned: "#3B82F6",
    InProgress: "#F59E0B",
    Completed: "#10B981",
    Cancelled: "#9CA3AF",
};

export const ScheduleCalendarStore = {
    namespaced: true,
    state: {
        calendarEvents: [],
        mySchedule: [],
        clashResult: null,
        isLoading: false,
    },
    mutations: {
        SET_CALENDAR_EVENTS(state, events) {
            state.calendarEvents = events;
        },
        SET_MY_SCHEDULE(state, schedule) {
            state.mySchedule = schedule;
        },
        SET_CLASH_RESULT(state, result) {
            state.clashResult = result;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
    },
    actions: {
        async fetchCalendar({ commit }, params) {
            commit("SET_LOADING", true);
            try {
                const queryString = buildCalendarQueryString(params);
                let data = await ScheduleService.getCalendar(`?${queryString}`);
                const events = (data.data || []).map(item => ({
                    id: item.assignment_id,
                    title: `${getEngineerName(item)} — ${getCustomerName(item)}`,
                    start: new Date(item.scheduled_date * 1000).toISOString().split("T")[0],
                    end: new Date((item.scheduled_date + 86400) * 1000).toISOString().split("T")[0],
                    backgroundColor: statusColours[item.status] || "#3B82F6",
                    borderColor: statusColours[item.status] || "#3B82F6",
                    extendedProps: {
                        schedule_id: item.schedule_id || (item.schedule && item.schedule.schedule_id),
                        engineer_id: item.engineer_id,
                        customer_name: getCustomerName(item),
                        job_id: item.schedule && item.schedule.job_id,
                        status: item.status,
                    },
                }));
                commit("SET_CALENDAR_EVENTS", events);
            } catch (error) {
                console.error("Error fetching calendar:", error);
                commit("SET_CALENDAR_EVENTS", []);
            } finally {
                commit("SET_LOADING", false);
            }
        },

        async fetchMySchedule({ commit }, params) {
            commit("SET_LOADING", true);
            try {
                const queryString = buildCalendarQueryString(params);
                let data = await ScheduleService.getMySchedule(`?${queryString}`);
                commit("SET_MY_SCHEDULE", data.data || []);
            } catch (error) {
                console.error("Error fetching my schedule:", error);
                commit("SET_MY_SCHEDULE", []);
            } finally {
                commit("SET_LOADING", false);
            }
        },

        async checkClashes({ commit }, payload) {
            try {
                let data = await ScheduleService.checkClashes(payload);
                commit("SET_CLASH_RESULT", data);
                return data;
            } catch (error) {
                console.error("Error checking clashes:", error);
                throw error;
            }
        },
    },
};

function getEngineerName(item) {
    if (item.engineer && item.engineer.name) return item.engineer.name;
    if (item.engineer_id) return item.engineer_id;
    return "Unassigned";
}

function getCustomerName(item) {
    if (item.customer && item.customer.name) return item.customer.name;
    return "";
}

function buildCalendarQueryString(params) {
    if (!params) return "";
    const filtered = {};
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
            filtered[key] = value;
        }
    });
    filtered._t = Date.now();
    return Object.entries(filtered)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
}
